<template>
    <div class="loginP">
        <div class="imgbox">
            <img src="../../assets/owner/Sign_in@2x.png" class="signBg" />
        </div>
        <div>

            <van-form >
                <van-field v-model="user.phone" type="number" name="手机号" label="手机号" label-width="60" placeholder="请输入手机号" />
                <van-field v-model="user.code" type="number" maxlength="6" center clearable label="验证码" label-width="60" placeholder="请输入验证码">
                    <template #button>
                        <van-button size="small" class="codeBtn" type="primary" :disabled="codeDis"
                            @click="getPhoneCode">
                            {{ codeBtnText }}</van-button>
                    </template>
                </van-field>
                <div style="margin: 32px 16px;">
                    <van-button round block type="info" class="submitBtn" @click="onSubmit">登录</van-button>
                </div>
            </van-form>

        </div>
    </div>
</template>

<script>
import { Toast } from 'vant';
import { getcode,loginByWx,validMobileShortCode,loginByPhone } from '../../apis/owner';
import {queryString} from '../../utils/getCodeUrl'

export default {
    data() {
        return {
            user: {
                phone: '',
                code: '',
            },
            codeBtnText: '获取验证码',
            timenum: 60,
            codeCountDown: '',
            codeDis: false,
            urldata:'',
            url:'',//完成操作需要跳转的路径
        }
    },
    mounted () {

        this.urldata = this.$route.query.urldata || '';
        this.url = queryString('url');
        if (this.$route.query.name) {
            document.title = this.$route.query.name;
        }
    },
    methods: {
        getPhoneCode() {
            let req = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
            if (!req.test(this.user.phone)) {
                Toast({
                    message: '请输入正确的手机号',
                    position: 'bottom',
                });
                return 
            }

            getcode( this.user.phone).then(res => {
                if (res.status == 0 && res.msg == 'SUCCESS') {
                    this.codeDis = true;
                    this.codeCountDown = setInterval(() => {
                        this.timenum--;
                        this.codeBtnText = `已发送(${this.timenum})s`
                        if (this.timenum <= 0) {
                            this.codeDis = false;
                            this.timenum = 60;
                            this.codeBtnText = '重新获取'
                            clearInterval(this.codeCountDown)
                        }
                    }, 1000);
                }
            })


        },
        onSubmit() {
            if (!this.user.phone) {
                Toast({
                    message: '请输入正确的手机号',
                    position: 'bottom',
                });
                return;
            }
            let req = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
            if (!req.test(this.user.phone)) {
                Toast({
                    message: '请输入正确的手机号',
                    position: 'bottom',
                });
                return 
            }
            if (!this.user.code) {
                Toast({
                    message: '请输入验证码',
                    position: 'bottom',
                });
                return;
            }
            validMobileShortCode({code :this.user.code,phone:this.user.phone}).then(result => {
                console.log(result)
                if(result.status == 0){
                    if(this.urldata == 'changePhone'){
                        this.getPhoneLogin();
                    }else{
                        this.wxLogin();
                    }
                    
                }else{
                    Toast({
                        message: result.msg,
                        position: 'bottom',
                    });
                }
            })
            

        },
        wxLogin(){
                let params = {
                    phone:this.user.phone,
                    openId:localStorage.getItem('openid'),
                }
                if(this.url == 'ownerinfo'){
                    loginByWx(params).then((res) => {
                        if(res.status == 0){
                            this.$store.state.ownerStates =  res.data.carOwnerCode;
                            if(res.data.carOwnerCode == 0){
                                this.$store.state.ownerInfo = {
                                    phone:res.data.carwx.wxPhone,
                                    sex:'0'
                                }
                                this.$router.push({
                                    path:'/ownerinfo'
                                })
                            }
                            if(res.data.carOwnerCode == 1){
                                this.$store.state.ownerInfo = res.data.CarOwnerInfo
                                this.$router.push({
                                    path:'/ownerinfo'
                                })
                            }
                            if(res.data.carOwnerCode == 2){
                                this.$store.state.ownerInfo = res.data.CarOwnerInfo
                                this.$router.push({
                                    path:'/ownercode'
                                })
                            }
                        }
                    })
                }else{
                    this.$router.push({
                        name:this.url,
                        params:{
                            phone:this.user.phone
                        }
                    })
                }
                
            
        },
        /**
         * 切换手机号
         */
        getPhoneLogin(){
            let params ={
                code:this.user.code,
                openId: localStorage.getItem('openid'),
                phone :this.user.phone,
            }
            loginByPhone(params).then((res) => {
                if(res.status == 0){
                    this.$router.push({
                        path :'/ownercode'
                    })
                }
            })
        }
    },
}
</script>

<style lang="scss" >
.loginP {
    padding: 15px;

    .imgbox {
        text-align: center;
        margin-bottom: 60px;

        .signBg {
            width: 72vw;
        }
    }

    .codeBtn {
        background: #EDEDED;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        border: 0;
    }

    .submitBtn {
        background: #FF323A;
        box-shadow: 2px 4px 8px 1px rgba(255, 72, 72, 0.45);
        border-radius: 46px;
        border: 0;
        font-size: 16px;
    }

    .van-field__label {
        font-size: 15px;
        font-weight: bold;
        color: #333333;
    }
    .van-cell{
        line-height: 42px;
        align-items: center;
        padding: 10px 5px;
    }
    .van-cell::after{
        right: 5px;
        left: 5px;
    }
}
</style>